import { BookNowButtonClicked } from './../../../core/store/general/actions';
import { isBookNowButtonClicked } from './../../../core/store/general/selectors';
import { SharedContainer } from './../../shared.container';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-payment-details',
    templateUrl: 'payment-details.component.html',
    styleUrls: ['./payment-details.component.css', './payment-details.component.scss']
})

export class PaymentDetailsComponent implements OnInit {

    @Input() visibility: boolean;
    @Input() type: string;
    @Output() updateCreditCardDetails: EventEmitter<any> = new EventEmitter();
    @Output() changeVisibility: EventEmitter<any> = new EventEmitter();

    title: string;

    countries = ['-', 'Afghanistan', 'Åland Islands', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla',
        'Antarctica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas',
        'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan',
        'Bolivia, Plurinational State of', 'State of Bonaire Sint Eustatius and Saba', 'Bosnia and Herzegovina',
        'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina',
        'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic Central', 'Chad',
        'Chile', 'China', 'Christmas', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo', 'Congo,', 'Cook', 'Costa', 'Côte',
        'Croatia', 'Cuba', 'Curaçao', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica Dominica', 'Dominican Republic',
        'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland', 'Faroe Islands',
        'Fiji', 'Finland', 'France', 'French', 'French', 'French', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar',
        'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-Bissau', 'Guyana',
        'Haiti', 'Heard Island and McDonald Islands', 'Holy See (Vatican City State)', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland',
        'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan',
        'Kazakhstan', 'Kenya', 'Kiribati', 'Korea,', 'Korea,', 'Kuwait', 'Kyrgyzstan', 'Lao', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia',
        'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macao', 'Macedonia,', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives',
        'Mali', 'Malta', 'Marshall', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia', 'Moldova', 'Monaco',
        'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands',
        'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern', 'Norway', 'Oman',
        'Pakistan', 'Palau', 'Palestinian', 'Panama', 'Papua', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn', 'Poland', 'Portugal',
        'Puerto Rico', 'Qatar', 'Réunion', 'Romania', 'Russian Federation', 'Rwanda', 'Saint Barthélemy', 'Saint Helena,',
        'Saint Kitts', 'Saint Lucia', 'Saint Martin', 'Saint Pierre', 'Saint Vincent', 'Samoa', 'San Marino', 'Sao Tome',
        'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Sint Maarten(Dutch part)',
        'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia', 'South Sudan', 'Spain',
        'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen', 'Swaziland', 'Sweden', 'Switzerland', 'Syrian',
        'Taiwan, Province of China', 'Tajikistan', 'Tanzania,', 'Thailand', 'Timor-Leste', 'Togo', 'Tokelau', 'Tonga',
        'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu', 'Uganda',
        'Ukraine', 'United ArabEmirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands',
        'Uruguay', 'Uzbekistan', 'Vanuatu', 'Venezuela,', 'Viet', 'Virgin Islands, British', 'Virgin Islands, U.S. ',
        'Wallis and Futuna', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe'];

    firstName = '';
    lastName = '';
    cardNumber = '';
    months = [];
    selectedMonth;
    scc = '';
    years = [];
    selectedYear;
    selectedCountry;

    cardTypes = ['American Express', 'Maestro', 'Visa', 'Euro / Mastercard'];
    selectedCardType;

    ccErrorNo = 0;
    ccErrors = new Array();

    bookNowEnabled = true;
    constructor(private sharedContainer: SharedContainer) {
    }

    ngOnInit() {
        if (this.isButtonsVisible()) {
            this.title = 'Update payment details';
        }
        this.title = 'Payment details';
        this.months.push('-');
        for (let i = 0; i < 13; i++) {
            if (i < 10) {
                this.months.push('0' + i);
            } else {
                this.months.push(i.toString());
            }
        }
        const start = new Date().getFullYear();

        for (let year = start; year < start + 30; year++) {
            this.years.push(year.toString());
        }
        this.selectedYear = this.years[0];

        this.ccErrors[0] = 'Unknown card type';
        this.ccErrors[1] = 'No card number provided';
        this.ccErrors[2] = 'Credit card number is in invalid format';
        this.ccErrors[3] = 'Credit card number is invalid';
        this.ccErrors[4] = 'Credit card number has an inappropriate number of digits';
        this.ccErrors[5] = 'Warning! This credit card number is associated with a scam attempt';

        this.sharedContainer.generalState$.select(isBookNowButtonClicked)
            .subscribe(reply => {
                if (reply === true) {
                    this.saveDeatails();
                    // this.bookNowEnabled = false;
                }
            });

    }

    isVisible() {
        return this.visibility;
    }

    keyPressNumbers(event) {
        const charCode = (event.which) ? event.which : event.keyCode;
        // Only Numbers 0-9
        if ((charCode < 48 || charCode > 57)) {
            event.preventDefault();
            return false;
        } else {
            return true;
        }
    }

    isButtonsVisible() {
        if (this.type === 'update-payment-details') { return true; }
        return false;
    }


    hideCard() {
        this.changeVisibility.emit(false);
    }

    isPaymentMissing() {
        return (this.firstName === '' || this.lastName === '' || this.cardNumber.toString() === '' ||
            this.selectedMonth === '' || this.scc === '' || this.selectedYear === '' ||
            this.selectedCardType === '');
    }



    checkCardInfo() {
        const paymentInputMissing = this.isPaymentMissing();
        if (this.isPaymentMissing()) {
            alert('Please fill in all of your payment details or ignore this message if no card is to be used');
            return false;
        }
        const creditCardNumberValid = this.checkCreditCard(this.cardNumber.toString(), this.selectedCardType);
        if (!creditCardNumberValid) {
            alert(this.ccErrors[this.ccErrorNo]);
            return false;
        }

        const expiryMonth = parseInt(this.selectedMonth, 10);
        const expiryYear = parseInt(this.selectedYear, 10);
        const currentMonth = new Date().getMonth();
        const currentYear = new Date().getFullYear();

        if (expiryYear === currentYear) {
            if (expiryMonth < currentMonth) {
                alert('Credit card expired');
                return false;
            }
        } else if (expiryYear < currentYear) {
            alert('Credit card expired');
            return false;
        }

        return true;
    }

    saveDeatails() {
        if (this.checkCardInfo()) {
            const cardDetails = {
                // isNewModel: true,
                account: this.cardNumber.toString(),
                fname: this.firstName,
                lname: this.lastName,
                secCode: parseInt(this.scc, 10),
                type: this.selectedCardType,
                endDate: new Date(parseInt(this.selectedYear, 10), parseInt(this.selectedMonth, 10), 0, 0, 0, 0, 0),
                country: 'Greece' // this.selectedCountry,
                // user: ''
            };
            this.updateCreditCardDetails.emit(cardDetails);
        }/* else {
            const cardDetails = {
                // isNewModel: true,
                account: 'No Data',
                fname: 'No Data',
                lname: 'No Data',
                secCode: 0o0,
                type: 'No Data',
                endDate: new Date(2050, 12, 0, 0, 0, 0, 0),
                country: 'Greece' // this.selectedCountry,
                // user: ''
            };
            this.updateCreditCardDetails.emit(cardDetails);
        }*/
        this.sharedContainer.generalState$.dispatch(new BookNowButtonClicked(1, { bookNowBtnClicked: false }));

    }



    checkCreditCard(cardnumber, cardname) {

        // Array to hold the permitted card characteristics
        const cards = new Array();

        // Define the cards we support. You may add addtional card types as follows.

        //  Name:         As in the selection box of the form - must be same as user's
        //  Length:       List of possible valid lengths of the card number for the card
        //  prefixes:     List of possible prefixes for the card
        //  checkdigit:   Boolean to say whether there is a check digit

        cards[0] = { name: 'Visa', length: '13,16', prefixes: '4', checkdigit: true };
        cards[1] = { name: 'Euro / Mastercard', length: '16', prefixes: '51,52,53,54,55', checkdigit: true };
        cards[2] = { name: 'American Express', length: '15', prefixes: '34,37', checkdigit: true };
        cards[3] = {
            name: 'Maestro', length: '12,13,14,15,16,18,19',
            prefixes: '5018,5020,5038,6304,6759,6761,6762,6763', checkdigit: true
        };
        cards[4] = { name: 'VisaElectron', length: '16', prefixes: '4026,417500,4508,4844,4913,4917', checkdigit: true };

        // Establish card type
        let cardType = -1;

        for (let i = 0; i < cards.length; i++) {
            // See if it is this card (ignoring the case of the string)
            if (cardname.toLowerCase().trim() === cards[i].name.toLowerCase().trim()) {
                cardType = i;
                break;
            }
        }

        // If card type not found, report an error
        if (cardType === -1) {
            this.ccErrorNo = 0;
            return false;
        }

        // Ensure that the user has provided a credit card number
        if (cardnumber.length === 0) {
            this.ccErrorNo = 1;
            return false;
        }

        // Now remove any spaces from the credit card number
        cardnumber = cardnumber.replace(/\s/g, '');

        // Check that the number is numeric
        const cardNo = cardnumber;
        const cardexp = /^[0-9]{13,19}$/;
        if (!cardexp.exec(cardNo)) {
            this.ccErrorNo = 2;
            return false;
        }

        // Now check the modulus 10 check digit - if required
        if (cards[cardType].checkdigit) {
            let checksum = 0;                                  // running checksum total
            const mychar = '';                                   // next char to process
            let j = 1;                                         // takes value of 1 or 2

            // Process each digit one by one starting at the right
            let calc;
            for (let i = cardNo.length - 1; i >= 0; i--) {
                // Extract the next digit and multiply by 1 or 2 on alternative digits.
                calc = Number(cardNo.charAt(i)) * j;
                // If the result is in two digits add 1 to the checksum total
                if (calc > 9) {
                    checksum = checksum + 1;
                    calc = calc - 10;
                }
                // Add the units element to the checksum total
                checksum = checksum + calc;
                // Switch the value of j
                if (j === 1) { j = 2; } else { j = 1; }
            }

            // All done - if checksum is divisible by 10, it is a valid modulus 10.
            // If not, report an error.
            if (checksum % 10 !== 0) {
                this.ccErrorNo = 3;
                return false;
            }
        }
        // Check it's not a spam number
        if (cardNo === '5490997771092064') {
            this.ccErrorNo = 5;
            return false;
        }

        // The following are the card-specific checks we undertake.
        let LengthValid = false;
        let PrefixValid = false;

        // We use these for holding the valid lengths and prefixes of a card type
        let prefix = new Array();
        let lengths = new Array();

        // Load an array with the valid prefixes for this card
        prefix = cards[cardType].prefixes.split(',');

        // Now see if any of them match what we have in the card number
        for (let i = 0; i < prefix.length; i++) {
            const exp = new RegExp('^' + prefix[i]);
            if (exp.test(cardNo)) { PrefixValid = true; }
        }

        // If it isn't a valid prefix there's no point at looking at the length
        if (!PrefixValid) {
            this.ccErrorNo = 3;
            return false;
        }
        // See if the length is valid for this card
        lengths = cards[cardType].length.split(',');
        for (let j = 0; j < lengths.length; j++) {
            if (cardNo.length.toString() === lengths[j]) { LengthValid = true; }
        }

        // See if all is OK by seeing if the length was valid. We only check the length if all else was
        // hunky dory.
        if (!LengthValid) {
            this.ccErrorNo = 4;
            return false;
        }
        // The credit card is in the required format.
        return true;
    }
}
